import { render, staticRenderFns } from "./EnvBlockLand.vue?vue&type=template&id=37b6d2b6&"
import script from "./EnvBlockLand.vue?vue&type=script&lang=js&"
export * from "./EnvBlockLand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports